import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import { EdwardColors } from 'enums';

export default makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      padding: theme.spacing(0,4),
    },
    movements: {
      '& .MuiTypography-body1': {
        margin: theme.spacing(3,0)
      },
      '& ul': {
        fontSize: '1rem'
      }
    },
    originalTitle: {
      background: EdwardColors.GRAY_EXTRALIGHT,
      padding: theme.spacing(1),
      fontSize: '20px',
      lineHeight: '32px',
      fontWeight: 800
    },
    originalSubtitle: {
      background: EdwardColors.GRAY_MEDIUM,
      color: '#fff',
      padding: theme.spacing(1),
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 900
    },
    originalInfo: {
      color: EdwardColors.GRAY_MEDIUM,
    },
    proposedTitle: {
      background: EdwardColors.DARKER,
      padding: theme.spacing(1),
      fontSize: '20px',
      lineHeight: '32px',
      fontWeight: 800
    },
    proposedSubtitle: {
      background: EdwardColors.MEDIUM,
      padding: theme.spacing(1),
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 900,
      '&.LONG_TERM': { background: EdwardColors.SECONDARY },
      '&.MID_TERM': { background: EdwardColors.DARK },
      '&.SHORT_TERM': { background: EdwardColors.LIGHTER }
    },
    movementsTitle: {
      background: EdwardColors.SECONDARY,
      padding: theme.spacing(1),
      fontSize: '20px',
      lineHeight: '32px',
      fontWeight: 800
    },
  }),
);
